import React from 'react';
import { connect } from 'react-redux';
import { Panel, Row, Col } from 'react-bootstrap';
import { fetchJob, notify } from 'actions';
import { FileUploader } from 'components';
import PropTypes from 'prop-types';

class JobFileUploader extends React.Component {
  render() {
    return (
      <Panel
        bsStyle='default'
        header={<h3 className="panel-title"><i className="fa fa-photo"></i> {this.props.title}</h3>}
        >
        <Row>
          <Col xs={12}>
            <h3 className="title">Upload</h3>
            <FileUploader
              ref='fileuploader'
              iconFiletypes={this.props.iconFiletypes}
              acceptedFiles={this.props.acceptedFiles}
              onSuccess={() => {
                this.refs.fileuploader.dropzone.removeAllFiles();
                this.props.fetchJob(this.props.job._id);
                this.props.notify(
                  { message : 'File upload successful!', title : 'Success!' },
                  { type : 'success' }
                );
              }}
              onError={error => this.props.notify(JSON.parse(error.xhr.response))}
              maxFiles={this.props.maxFiles}
              endpoint={this.props.endpoint}
            />
          </Col>
          <Col xs={12}>
            <h3 className="title">Preview</h3>
            {this.props.preview}
          </Col>
        </Row>
      </Panel>
    );
  }
}

JobFileUploader.propTypes = {
  job: PropTypes.object.isRequired,
  endpoint: PropTypes.string.isRequired,
  title: PropTypes.string,
  iconFileTypes: PropTypes.arrayOf(PropTypes.string),
  acceptedFiles: PropTypes.string,
  maxFiles: PropTypes.number,
  preview: PropTypes.object     // component
};

export default connect(null, { fetchJob, notify })(JobFileUploader);



// WEBPACK FOOTER //
// ./src/browser/components/client/jobs/job-file-uploader.js